import axios from '@/core/axios';

import { CollectionList } from '../collections/collections.types';
import {
  AccountingMapping,
  AccountingMappingPayload,
  AccountingMappingsListOptions
} from './accounting-mappings.types';

export class AccountingMappingsService {
  async list(opts: AccountingMappingsListOptions = {}): Promise<CollectionList<'accounting-mappings'>> {
    const { filters, pagination } = opts;
    const resp = await axios.get<CollectionList<'accounting-mappings'>>('/accounting/mappings', {
      params: { ...filters, ...pagination }
    });
    return resp?.data;
  }

  async get(id: number): Promise<AccountingMapping> {
    const resp = await axios.get<AccountingMapping>(`/accounting/mappings/${id}`);
    return resp?.data;
  }

  async newMapping(): Promise<AccountingMapping> {
    const resp = await axios.get<AccountingMapping>(`/accounting/mappings/new`);
    return resp?.data;
  }

  async create(payload: AccountingMappingPayload): Promise<AccountingMapping> {
    const resp = await axios.post<AccountingMapping>(`/accounting/mappings`, { accounting_mapping: payload });
    return resp?.data;
  }

  async update(id: number, payload: Partial<AccountingMappingPayload>): Promise<AccountingMapping> {
    const resp = await axios.put<AccountingMapping>(`/accounting/mappings/${id}`, { accounting_mapping: payload });
    return resp?.data;
  }

  async commissionTypes(): Promise<string[]> {
    const resp = await axios.get<string[]>('/accounting/mappings/commission-types');
    return resp?.data;
  }
}

export const accountingMappingsService = new AccountingMappingsService();
